(() => {
  const initialized = new WeakSet();
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const initialize = (root) => {
    root.querySelectorAll('.product-card--has-hover-image').forEach((card) => {
      if (initialized.has(card)) return;
      initialized.add(card);
      const image = card.querySelector('[data-hover-image]');
      let loading = false;
      const load = async () => {
        if (!pointer.matches || !image || loading || card.classList.contains('is-hover-ready')) return;
        loading = true;
        image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        try {
          await image.decode();
          card.classList.add('is-hover-ready');
        } catch {
          loading = false;
        }
      };
      card.addEventListener('pointerenter', load);
      card.addEventListener('focusin', load);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

if (!customElements.get('loop-collection-navigation')) {
  customElements.define('loop-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggle = this.querySelector('.collection-bar__toggle');
      this.panel = this.querySelector('.collection-bar__options');
      let open = false;
      try { open = sessionStorage.getItem('5loop:collections-open') === 'true'; } catch {}
      this.setOpen(open);
      requestAnimationFrame(() => {
        const active = this.panel.querySelector('[aria-current="page"]');
        if (active) this.panel.scrollLeft = Math.max(0, this.panel.scrollLeft + active.getBoundingClientRect().left - this.panel.getBoundingClientRect().left - this.panel.clientWidth / 2 + active.offsetWidth / 2);
      });
      this.toggle.addEventListener('click', () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true'), options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.setOpen(false);
          this.toggle.focus();
        }
      }, options);
    }
    setOpen(open) {
      this.classList.toggle('is-open', open);
      this.toggle.setAttribute('aria-expanded', String(open));
      this.panel.inert = !open;
      try { sessionStorage.setItem('5loop:collections-open', String(open)); } catch {}

    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

(() => {
  const countdowns = [...document.querySelectorAll('[data-drop-countdown]')];
  if (countdowns.length === 0) return;

  const pad = (value) => String(value).padStart(2, '0');

  const formatRemaining = (milliseconds) => {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (days > 0) return `${days}D ${pad(hours)}H ${pad(minutes)}M`;
    if (hours > 0) return `${hours}H ${pad(minutes)}M ${pad(seconds)}S`;
    return `${pad(minutes)}M ${pad(seconds)}S`;
  };

  const revealScheduledProducts = (target) => {
    const preview = [...document.querySelectorAll('[data-drop-reveal]')].find(
      (candidate) => candidate.dataset.dropReveal === target,
    );
    if (!preview) return;

    const reloadKey = `5loop:drop-reload:${target}`;
    try {
      if (sessionStorage.getItem(reloadKey)) return;
      sessionStorage.setItem(reloadKey, '1');
    } catch (error) {
      // The reload is still safe when storage is unavailable.
    }

    window.setTimeout(() => window.location.reload(), 800);
  };

  const update = () => {
    const now = Date.now();

    countdowns.forEach((countdown) => {
      const target = countdown.dataset.dropCountdown;
      const targetTime = Date.parse(target);
      if (!Number.isFinite(targetTime)) {
        countdown.hidden = true;
        return;
      }

      const remaining = targetTime - now;
      if (remaining <= 0) {
        countdown.textContent = 'LIVE NOW';
        countdown.classList.add('is-live');
        revealScheduledProducts(target);
        return;
      }

      const prefix = countdown.dataset.dropPrefix || 'DROP IN';
      countdown.textContent = `${prefix} ${formatRemaining(remaining)}`;
    });
  };

  update();
  window.setInterval(update, 1000);
})();
